<template>
  <div class="containerForm">
    <div style="margin-bottom: 10px; margin-top: 10px; display: flex; justify-content: space-between">
      <el-button @click="handleData">刷新</el-button>
      <el-button @click="goZL">一屏通览</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="自定义身份名称" prop="name" />
      <el-table-column label="身份类型" prop="identityName" />
      <el-table-column label="时间">
        <template #default="{ row }">
          <template v-if="row.exportParams && row.exportParams.status == 'SUCCESS'">
            <el-tag type="success">生成成功 {{ handleDate(row.exportParams.createTime) }}</el-tag>
          </template>
          <template v-if="row.exportParams && row.exportParams.status == 'PENDING'">
            <el-tag type="info">正在生成中... {{ handleDate(row.exportParams.createTime) }}</el-tag>
          </template>
          <template v-if="row.exportParams && row.exportParams.status == 'FAIL'">
            <el-tag type="danger">
              生成失败: {{ row.exportParams.remark }}{{ handleDate(row.exportParams.createTime) }}
            </el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" show-overflow-tooltip>
        <template #default="{ row }">
          <el-button v-if="!row.isExport" type="primary" @click="handleOpenDialog(row)">生成报表</el-button>
          <template v-else>
            <template v-if="row.exportParams.status == 'SUCCESS'">
              <el-button type="primary" @click="handleOpenDialog(row)">重新生成</el-button>
              <el-button type="success" @click="exportFile(row)">下载报表</el-button>
            </template>
            <template v-if="row.exportParams.status == 'PENDING'">
              <el-button type="info">重新生成</el-button>
            </template>
            <template v-if="row.exportParams.status == 'FAIL'">
              <el-button type="primary" @click="handleOpenDialog(row)">重新生成</el-button>
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-model="visible" title="提示">
      <p>
        因我方运营需求，需要生成并导出用户信息。导出的用户信息仅用于运营用途，我方承诺不会泄露用户隐私。如有泄露或造成纠纷，我方会承担相应法律责任。
      </p>
      <el-checkbox v-model="isCheck" label="请勾选确认" size="large" />
      <template #footer>
        <el-button v-if="pararms.type != `MEETING_SIGN_REPORT`" type="primary" @click="handleExport(checkRow, 'N')">
          导出脱敏信息
        </el-button>
        <el-button type="primary" @click="handleExport(checkRow, 'Y')">导出完整信息</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import { getRegisterConfigList, dataGetB, dataExportB } from '@/api/exhibitionManage'
  import { useRouter } from 'vue-router'
  import { parseTime } from '@/utils/index'

  export default defineComponent({
    name: 'JbhZHCG',
    setup(props, { emit }) {
      const router = useRouter()

      const { proxy } = getCurrentInstance()

      const state = reactive({
        form: {
          categoryName: '',
          meetingCode: '',
          originalPrice: '',
          remark: '',
          sellingPrice: '',
          sort: '',
          coverUrl: '',
        },
        direction: 'rtl',
        size: '50%',
        pararms: {
          type: 'MEETING_REGISTER_REPORT',
        },
        title: '综合成果展示',
        tableData: [],
        isCheck: false,
        visible: false,
        checkRow: {},
      })

      const handleData = async () => {
        try {
          let { data } = await getRegisterConfigList(state.form.code)

          const { data: list } = await dataGetB(state.pararms)

          if (state.pararms.type == `MEETING_SIGN_REPORT`) {
            data = [
              {
                name: '签到数据',
                identity: 'AUDIENCE',
                isExport: list.length > 0 ? true : false,
                exportParams: list.length > 0 ? list[list.length - 1] : {},
              },
            ]
          } else if (state.pararms.type == 'EXHIBITION_FORUM_REGISTER_REPORT') {
            data = [
              {
                name: '会议数据',
                identity: 'AUDIENCE',
                isExport: list.length > 0 ? true : false,
                exportParams: list.length > 0 ? list[list.length - 1] : {},
              },
            ]
          } else if (state.pararms.type == 'TICKET_REGISTER_REPORT') {
            data = [
              {
                name: '门票表单下载',
                identity: 'AUDIENCE',
                isExport: list.length > 0 ? true : false,
                exportParams: list.length > 0 ? list[list.length - 1] : {},
              },
            ]
          } else {
            data.forEach((v) => {
              v.isExport = false
            })

            if (list.length > 0) {
              list.forEach((v) => {
                data.forEach((sv) => {
                  if (v.subType == sv.identity) {
                    sv.isExport = true
                    sv.exportParams = v
                  }
                })
              })
            }
          }

          state.tableData = data
        } catch (err) {
          console.log(err, '----')
        }
      }

      const handleOpenDialog = async (row) => {
        state.checkRow = row
        state.visible = true
      }

      const handleExport = async (row, isReal) => {
        if (!state.isCheck) {
          proxy.$baseMessage(`请先勾选确认`, 'error', 'vab-hey-message-error')
          return false
        }
        let params = {
          subType: row.identity,
          type: state.pararms.type,
          relationCode: state.form.code,
          relationType: state.form.relationType,
          isReal,
        }
        state.checkRow = {}
        state.visible = false
        state.isCheck = false
        try {
          const { data } = await dataExportB(params)
          console.log(data)
          handleData()
        } catch (err) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      const exportFile = (row) => {
        window.open(row.exportParams.fileUrl)
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      onMounted(() => {
        const row = {
          code: 'EX1920026354275885056',
          relationType: 'EXHIBITION',
          type: 'MEETING_REGISTER_REPORT',
        }
        state.pararms = {
          relationCode: row.code,
          relationType: row.relationType,
          type: row.type,
        }
        state.form = Object.assign(state.form, row)
        handleData()
      })

      function goZL() {
        router.push('/zhcggl/jbh_YJTL')
      }

      return {
        ...toRefs(state),
        handleExport,
        exportFile,
        handleDate,
        handleData,
        handleOpenDialog,
        goZL,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .containerForm {
    height: 85vh;
    width: 100%;
    overflow-y: auto;
    padding: 16px;
  }
</style>
